export const MuiButtonMainProps =  {
    variant: "contained",
    color: "primary",
    // size: "medium"
};